import React from "react";
import { useLocalStorageState } from "ahooks";
import { useEffect } from "react";
import { CloseOutlined } from "@ant-design/icons";

export default function GameTips(props) {
  const [load, setLoad] = useLocalStorageState("gameTipsLoad", true);
  useEffect(() => {
    return () => {
      setLoad(false);
    };
  }, []);

  return (
    <div
      style={{
        padding: "0px 15px 5px",
        position: "relative",
        backgroundColor: "white",
        display: load || props?.show ? "block" : "none",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: -5,
          right: 40,
          transform: "rotate(45deg)",
          backgroundColor: "#FFF6F6",
          width: 15,
          height: 15,
        }}
      ></div>
      <div
        style={{
          backgroundColor: "#FFF6F6",
          borderRadius: 8,
          padding: 15,
          color: "#666",
          fontSize: "0.26rem",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <img src="resources/250627/tips.png" alt="" height={14} />
          <CloseOutlined
            onClick={() => {
              setLoad(false)
              if (props?.onClose) {
                props.onClose();
              }
            }}
            style={{ color: "#999" }}
          />
        </div>
        <div style={{ paddingTop: 5 }}>
          {props?.free_version_introduce.content || ''}
        </div>
      </div>
    </div>
  );
}
